var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 4.42334L8.66406 7.67334L12.6641 4.42334",
    stroke: "#A7A7A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 11.8523V2.56662C0.664062 2.07407 0.832633 1.6017 1.13269 1.25342C1.43275 0.905135 1.83972 0.709473 2.26406 0.709473H15.0641C15.4884 0.709473 15.8954 0.905135 16.1954 1.25342C16.4955 1.6017 16.6641 2.07407 16.6641 2.56662V11.8523C16.6641 12.3449 16.4955 12.8172 16.1954 13.1655C15.8954 13.5138 15.4884 13.7095 15.0641 13.7095H2.26406C1.83972 13.7095 1.43275 13.5138 1.13269 13.1655C0.832633 12.8172 0.664063 12.3449 0.664062 11.8523Z",
    stroke: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.d8c87b4aa79e597fed21fa910954e66a.svg";
export { ForwardRef as ReactComponent };